define('model/ClientTimeZoneModel',['require','model/TimeZoneModel','Config'],function (require) {

    var TimeZoneModel = require('model/TimeZoneModel');
    var Config = require('Config');

    return TimeZoneModel.extend({

        url: '/time-zone/client/',

        isReady: function () {
            if (parseInt(Config.getInstance().getOption('show_booking_page_in_client_timezone'))) {
                if (this.isNew()) {
                    return false;
                }
            }
            return true;
        }

    });

});
